import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to store 'dsj_lead_source' from URL's 'profile' query parameter into local storage.
 * Meant to be used by Registration to record lead source to students_information table
 *
 * Usage:
 * - If URL is `...?profile={"dsj_lead_source":"google"}`, it sets 'dsj_lead_source' as 'google' in local storage.
 */
export function useStoreLeadSource() {
  var location = useLocation();
  useEffect(function () {
    var profileParam = new URLSearchParams(location.search).get('profile');
    if (profileParam) {
      try {
        var profileObject = JSON.parse(decodeURIComponent(profileParam));
        if (profileObject.dsj_lead_source) {
          localStorage.setItem('dsj_lead_source', profileObject.dsj_lead_source);
        }
      } catch (error) {
        console.error('Issue setting dsj_lead_source into local storage', error);
      }
    }
  }, [location.search]);
}